<template lang="pug">
  router-view(v-if="current && current.ouvidoria")
  .empty.mx-2(v-else)
    .empty-icon
      i.fa.fa-bullhorn.fa-3x
    p.empty-title.h5 Ops!!!
    p.empty-subtitle A #[b Ouvidoria - Acesso Cidadão] não foi ativada neste município
</template>

<script>
  export default {
    vuex: {
      info: {
        state: ['current']
      }
    }
  }
</script>
